let _authState = null // null = unchecked, true = authenticated, false = not authenticated

export const getAuthState = () => _authState
export const setAuthState = (val) => { _authState = val }
